"use strict";

import React, {useEffect, useState} from "react";


const ContactFormErrors = ({errors={}}) => {
    //<small className="form__error">{errors['contact-company'][key].message}</small>

    if (Object.keys(errors) <= 1) {
        return <></>
    }

    return (
        <>
            {Object.entries(errors).map(([key,val])=>
                (typeof val === 'string' ? <small className="form__error" key={key}>{val}</small> : <></>)
            )}
        </>
    )
}

export default  ContactFormErrors;